import React, {Fragment} from 'react'
import {connect} from 'react-redux'
import {ApplicationState, ConnectedReduxProps} from '@reducers/index'
import {User} from '@models/user'
import {deleteRequest, fetchRequest} from '@actions/user'
import UserForm from "@components/users/Form";
import {createRequest, updateRequest} from '@actions/user';
import userApi from '@api/user'
import {injectIntl} from 'react-intl';


interface PropsFromState {
  loading: boolean
  data: User[]
  errors?: string,
  count: number
}

interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest
  deleteRequest: typeof deleteRequest
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps


class UserFormPage extends React.Component<AllProps> {
  
  state = {
    user : null,
    user_id : this.props.match.params.id,
    is_fetched : false
  };
  
  componentDidMount(){
    if(this.state.user_id){
      this.fetchItem();
    }
  }
  
  fetchItem = () => {
    userApi.getItem({
        params: {
          id: this.state.user_id,
        }
      })
      .then(({data}) => {
        this.setState({
          user : data
        })
      })
      .catch((error) => console.log(error))
  };
  
  getContent = () => {
    if(this.state.user_id && !this.state.user){
      return null
    }
    
    return (
      <UserForm user={this.state.user}
               intl={this.props.intl}
               listUrl={"/users"}
               history={this.props.history}
               updateRequest={this.props.updateRequest}
               createRequest={this.props.createRequest}/>
    )
  };
  
  render() {
    return (
      <Fragment>
        {this.getContent()}
      </Fragment>
    )
  }
}



const mapStateToProps = ({users}: ApplicationState) => ({
  loading: users.loading,
  errors: users.errors
});

const mapDispatchToProps = {
  createRequest,
  updateRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(
  injectIntl(UserFormPage));



